import { Divider, Icon, Text } from '@cascade/ui-library';
import classes from './Page.module.scss';
import type { TPageProps } from './Page.types.ts';

export const Page = ({ iconType, title, children }: TPageProps) => (
  <div className={classes.page}>
    {title ? (
      <>
        <div className={classes.heading}>
          <Icon type={iconType} size='3xl' />
          <Text type='h1' weight='semibold' content={title} compact />
        </div>
        <Divider />
      </>
    ) : null}
    {children}
  </div>
);
